<template>
  <div>
    <div class="myPanel">
      <div class="form-group">
        <a role="button" class="btn btn-primary myButton" @click="btnGotoInfo">掃我的QRCode</a>
        <small class="form-text text-muted">會議報到識別證掃描</small>
      </div>
      <div class="form-group">
        <a role="button" class="btn btn-primary myButton" @click="btnGotoScanCode">掃會議QRCode</a>
        <small class="form-text text-muted">會議門口 QRCode掃描</small>
      </div>
      <div class="form-group">
        <a role="button" class="btn btn-primary myButton" @click="btnTest">test</a>
        <small class="form-text text-muted">會議門口 QRCode掃描</small>
      </div>

      <hr>
      <h1>已報到場次</h1>
      <ul>
        <li>xxxxx</li>
      </ul>
    </div>
  </div>
</template>

<script>
/**

 **/


export default {
  //name: "index",
  // props: [""],
  data: function () {
    return {
      id: "",
      dataReady: false,
      formData: {
        name: "",
      },
    };
  },
  methods: {
    async loadData() {
      // let data=await apiUtil.api_SupplierTODO("12138114-01")

      // this.data=data
    },
    btnGotoInfo(){
      this.$router.push({ name: 'CheckInClientInfoMember', query: { ID: 0 }})
    },
    btnGotoScanCode(){
      // this.$router.push({ name: 'CheckInClientScanCode', query: { ID: 0 }})
    },
    btnTest(){
      this.$router.push({ name: 'm', query:{id:"219d795d-9d2e-42cd-978c-3ba4d3085ca7"}})
    }
  },
  mounted() {
    //this.loadData()
  },
}
</script>

<style scoped>
  .myPanel{
    max-width:500px;
    margin:0 auto;
  }

  .myButton{
    width:300px;
    color:white;
  }
</style>
